module.exports = __webpack_public_path__ + "img/ExitusMujer-Calle.dfe3cdad.png";